import type { FaireThemeEntity } from "../../entity_types/theme";

export const rustic_depot_popcorn_wall_bold_flavors_samplers: FaireThemeEntity =
  {
    token: "rustic-depot-popcorn-wall-bold-flavors-samplers",
    type: "theme",
    retailerToken: "r_464eox2tas",
    name: "Popcorn Wall",
    description: "Bold popcorn display that draws customers in",
    bgColor: "#E8D8E8",
    tileBgColor: "#866c2c",
    productTokens: [
      "p_ng88c4mkn4",
      "p_3fnduwwp45",
      "p_t735dkivfd",
      "p_gw7fq4hdtv",
    ],
    exactProducts: true,
    meta: {
      source: "mock",
      importedAt: "2026-03-24T13:50:10Z",
      importedBy: "retailer-themes-entity-migration",
    },
  };
